<template>
    <main>
        <div class="wrapper">
            <h1 class="heading--default">ビジネスキャラ診断</h1>
            <div class="question__wrap">
                <div class="question__explanation">
                    <p class="explanation__text text-left">
<!--                        仕事をするにあたり、重要な取引先（顧客、クライエント、パートナーなど）との付き合い方、評価される仕事の内容、同業他社や同僚との関係について左右の文章を比較し、普段のあなたにより近いのはどちらでしょうか。-->
                        仕事をするにあたって、重要な取引先（顧客、クライアント、パートナーなど）との付き合い方、評価される仕事の内容、同僚や同業他社との関係について左右の文章を比較し、普段のあなたにより近いのはどちらでしょうか。
                        <br>近い番号を選んで下さい。
                    </p>
                    <div class="options__row">
                        <div class="column-6">
                            <div class="option">1</div>
                            <p>完全に左寄り</p>
                        </div>
                        <div class="column-6">
                            <div class="option">2</div>
                            <p>やや左寄り</p>
                        </div>
                        <div class="column-6">
                            <div class="option">3</div>
                            <p>やや右寄り</p>
                        </div>
                        <div class="column-6">
                            <div class="option">4</div>
                            <p>完全に右寄り</p>
                        </div>
                    </div>
                </div>

                <Question v-for="question in this.testData.questions"
                          :question_no="question.no"
                          :active="question.active"
                          :question_left="question.question_left"
                          :question_right="question.question_right"
                          :question_answer="this.testData.state.currentPageAnswers[question.no]"
                          @clickQuestionAnswer="clickQuestionAnswer" />

                <div class="action__row">
                    <button id="result_btn"
                            type="submit"
                            :disabled="!isAllAnswered"
                            :class="{
                                active: isAllAnswered,
                                inactive:!isAllAnswered
                            }"
                            @click="(event)=>endTest( event )">診断結果を見る</button>
                </div>

            </div>
        </div>

        <!-- Counter -->
        <Counter :countAnswered="countAnswered" :timeLeftMinutes="timeLeftMinutes" :timeLeftSecond="timeLeftSecond" />

    </main>

    <!-- Footer -->
    <footer class="footer">Powered by SiteEngine Inc.</footer>
</template>

<script>
import Question from './components/Question'
import Counter from './components/Counter'
import axios from 'axios'
import {moveToUrl} from '../common'
import TestData from './TestData'


export default {
    components: {
        Question,
        Counter,
    },
    name: "App",
    data(){
        return {
            timeLeft : null,
            testData : null
        }
    },
    methods: {
        /**
         * @param event
         */
        endTest(event){

            axios.post('/api/enneagram/employee/end_test',this.testData.state)
            .then((response)=>{

                this.testData.state.answerStart = response.data.answerStart
                this.testData.state.answerEnd = response.data.answerEnd
                this.testData.state.answerCompleted = response.data.answerCompleted
                this.testData.saveToLocalStorage()
                this.toResultPage()
            })

        },
        /**
         *
         * @param question_no 質問番号
         * @param answer_no 回答選択番号
         * @param event クリックイベント
         */
        clickQuestionAnswer({question_no,answer_no,event}){

            //回答内容を格納
            this.testData.state.currentPageAnswers[question_no] = answer_no

            this.testData.saveToLocalStorage()

            //全質問回答済みなら「診断結果を見る」ボタンにページ内遷移
            if (this.isAllAnswered) {
                localStorage.setItem('last_element','result_btn')
                this.moveTo(document.getElementById('result_btn'))
                return
            }

            //未回答質問あり

            //次に移動先となる質問番号を取得
            const next_question_no = this.getNextMoveQuestionNumber(question_no)
            localStorage.setItem('last_element', next_question_no)

            //次の質問に遷移
            this.moveTo(document.querySelectorAll('.question')[next_question_no-1])

            //質問表示をアクティブ化
            this.testData.questions.map((question_data)=>{
                //質問が非アクティブ表示
                if (question_data.no===parseInt(question_no)||question_data.no===parseInt(next_question_no)) {
                    //今回の回答選択肢 又は 次の移動先の回答選択肢 ならアクティブ表示にする
                    if (!question_data.active)
                        question_data.active = true
                }
                return question_data
            })

            this.testData.saveToLocalStorage()

        },
        /**
         * 次の質問番号を取得
         * @param question_no
         * @returns {string}
         */
        getNextMoveQuestionNumber(question_no){

            const question_key_numbers = Object.keys(this.testData.state.currentPageAnswers)

            //回答した質問番号以降で未回答の質問を確認
            const following_keys = question_key_numbers.slice(question_no)

            for( let i= 0 ; i < following_keys.length ; i++){
                const no = following_keys[i]
                if (this.testData.state.currentPageAnswers[no]===null) {
                    //未回答が見つかれば移動
                    return no
                }
            }

            //回答した質問番号より前で未回答の質問を確認
            const previous_keys = question_key_numbers.slice(0,question_no)

            for( let i= 0 ; i < previous_keys.length ; i++){
                const no = previous_keys[i]
                if (this.testData.state.currentPageAnswers[no]===null) {
                    return no
                }
            }
        },

        moveTo(element){
            const duration = 500
            const offset = -150
            this.$scrollTo(element,duration,{offset})
        },

        /**
         * 残り時間更新
         */
        updateTimeLeft(){

            if (this.testData.state.answerEnd==='')
                return

            const endDate = new Date(this.testData.state.answerEnd)
            this.timeLeft = Math.floor((endDate - new Date()) / 1000)
        },

        /**
         * 結果ページへ遷移
         */
        toResultPage(){
            // moveToUrl( '/enneagram_test/result/' + window.Laravel.employee.uuid )
            moveToUrl( '/business_character_test/result/' + window.Laravel.employee.uuid )
        }
    },
    computed: {
        /**
         * 全質問回答済みならtrue
         */
        isAllAnswered(){

            return this.testData.isAllAnswered()
        },
        /**
         * 回答済み質問の件数　
         * @returns {number}
         */
        countAnswered(){

            const question_key_numbers = Object.entries(this.testData.state.currentPageAnswers)

            //回答番号がnull以外でフィルター
            const answered = question_key_numbers.filter( ([_,answer_no])=>answer_no!==null )

            //回答済み質問の件数
            return answered.length
        },
        /**
         * 残り時間（分）
         * @returns {string|number}
         */
        timeLeftMinutes(){

            if (this.timeLeft===null) return '--'

            return Math.floor(this.timeLeft / 60)
        },
        /**
         * 残り時間（病）
          * @returns {string}
         */
        timeLeftSecond(){

            if (this.timeLeft===null) return '--'

            return ("0" + this.timeLeft % 60).slice(-2)
        },
    },
    mounted(){

        //テスト完了していたら完了ページへ遷移
        if (this.testData.isAnswerCompleted()) {
            this.toResultPage()
        }
    },
    beforeCreate() {
    },

    created() {
        console.log('test beforeCreate')

        console.log('WWWWWWWW : 2')

        const testData = new TestData

        testData.load()

        const lastQuestionElement = testData.lastQuestionElement

        this.testData = testData;

        this.updateTimeLeft()

        setTimeout(()=>{

            // 結果ボタンへジャンプ
            if (lastQuestionElement === 'result_btn') {

                this.moveTo(document.getElementById('result_btn'))
            }
            // 最後に答えた質問へジャンプ
            else if(!Number.isNaN(lastQuestionElement)) {

                this.moveTo(document.querySelectorAll('.question')[lastQuestionElement-1])
            }

        },0)

        //テスト開始処理
        axios.post('/api/enneagram/employee/start_test').then((response)=>{

            // テスト開始時間
            this.testData.state.answerStart = response.data.answerStart
            // テスト終了予定時刻
            this.testData.state.answerEnd = response.data.answerEnd
            // テスト完了フラグ
            this.testData.state.answerCompleted = response.data.answerCompleted
            // ローカルストレージにデータを保存
            this.testData.saveToLocalStorage()

            // 残り時間を更新
            this.updateTimeLeft()

            // 1秒ごとに残り時間を減らす処理
            const intervalId = setInterval(()=>{

                // 残り時間を更新
                this.updateTimeLeft()

                // 時間切れ処理
                if　(this.timeLeft <= 0) {

                    // タイマー停止
                    clearInterval(intervalId)

                    try{
                        // サーバ側でタイムアップ処理（テスト完了フラグを更新）
                        axios.get( '/api/enneagram/employee/timeup/'+window.Laravel.employee.uuid )
                        // 結果ページへ遷移
                        .then(response=>{
                            this.toResultPage()
                        })
                        .catch(error=>{

                        })
                    }
                    catch(error){

                    }

                }
            },1000)
        })


        console.log('WWWWWWWW : 2')
    },
}
</script>

<style scoped>

</style>
